import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { DsHTTPStatus } from '@direction/auth';
import { ResourceService } from '@direction/translate';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements AfterViewInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private httpStatus: DsHTTPStatus,
    private spinner: NgxSpinnerService,
    private resource: ResourceService
  ) {
    this.httpStatus
      .getHttpStatus()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((status: boolean) => {
        if (status) {
          //this.spinner.show();
        } else {
          this.spinner.hide();
        }
      });
  }

  ngAfterViewInit(): void {
    const cardBody: HTMLElement = document.querySelector('lds-auth');
    const observer = new MutationObserver(() => {
      this.checkTerms();
    });

    observer.observe(cardBody, {
      childList: true, // mudanças em filhos imediatos
      subtree: true // captura também netos/descendentes
    });
  }

  private checkTerms(): void {
    if (
      !document.getElementById('ds-auth-policy-links') &&
      document
        .querySelector('.login-container > .card-body')
        .innerHTML.includes(this.resource.getResource('@direction.auth.login.loginButtonText'))
    ) {
      this.addPolicyLinks();
    }
  }

  private addPolicyLinks(): void {
    const cardBody: HTMLElement = document.querySelector('.login-container > .card-body');
    cardBody.style.position = 'relative';

    const linksContainer = document.createElement('div');
    linksContainer.id = 'ds-auth-policy-links';
    linksContainer.style.position = 'absolute';

    const policy = document.createElement('a');
    policy.href = 'assets/templates/privacy-policy.html';
    policy.innerText = 'Política de privacidade';

    const terms = document.createElement('a');
    terms.href = 'assets/templates/terms.html';
    terms.innerText = 'Termos e condições';

    const contact = document.createElement('a');
    contact.href = 'mailto:info@fitrus.com.br';
    contact.innerText = 'Contato';

    linksContainer.appendChild(policy);
    linksContainer.appendChild(document.createElement('div'));
    linksContainer.appendChild(terms);
    linksContainer.appendChild(document.createElement('div'));
    linksContainer.appendChild(contact);

    cardBody.appendChild(linksContainer);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
